import { AlertColor } from '@mui/material'
import {
  orangeShades,
  whiteShades,
  primaryColors
} from '@assets/styles/helpers/colors.styles'

export const getIconBySeverity = (
  severity: AlertColor,
  iconSize: 'icon-big' | 'icon-medium'
) => {
  switch (severity) {
    case 'success':
      return (
        <i
          className={`las la-check-circle ${iconSize}`}
          style={{ color: primaryColors.white }}
        />
      )
    case 'error':
      return (
        <i
          className={`las la-exclamation-circle  ${iconSize}`}
          style={{ color: primaryColors.orange }}
        />
      )
    case 'info':
      return (
        <i
          className={`las la-info-circle  ${iconSize}`}
          style={{ color: whiteShades.shade1 }}
        />
      )
    case 'warning':
      return (
        <i
          className={`las la-exclamation-triangle ${iconSize}`}
          style={{ color: orangeShades.shade1 }}
        />
      )
    default:
      return null
  }
}
